import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { colors, mono } from "../theme/tokens";

const contactEmail = "support@renoten.com";
const linkedInUrl = "https://www.linkedin.com/company/renoten/";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const linkSx = {
    fontFamily: mono,
    fontSize: "12px",
    color: colors.muted,
    textDecoration: "none",
    "&:hover": { color: colors.primary },
  };

  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 3, md: 6 },
        py: 3,
        borderTop: `1px solid ${colors.border}`,
        background: colors.surface,
        flexWrap: "wrap",
        gap: 1.5,
      }}
    >
      <Typography
        sx={{ fontFamily: mono, fontSize: "12px", color: colors.faint }}
      >
        © {currentYear} RENOTEN
      </Typography>
      <Box sx={{ display: "flex", gap: 2.5, flexWrap: "wrap" }}>
        <Link component={RouterLink} to="/privacy-policy" sx={linkSx}>
          Privacy Policy
        </Link>
        <Link component={RouterLink} to="/blog" sx={linkSx}>
          Blog
        </Link>
        <Link href={`mailto:${contactEmail}`} sx={linkSx}>
          Contact
        </Link>
        <Link
          href={linkedInUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={linkSx}
        >
          LinkedIn
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
